export {
    EVENT_TYPE,
    LoadingCards,
    ORGANIZER_ARTICLE_TYPE,
    ORGANIZER_TYPE,
} from './LoadingCards';
import { LoadingCards } from './LoadingCards';

export default LoadingCards;
